require('ng-pendo');

window.pendo_options = {
    apiKey: '5c4c5d90-e48a-41e4-6d3c-bc2633291a48',
    usePendoAgentAPI: true
};
